import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCopy = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20.67 5.983 18.516 3.83a1.12 1.12 0 0 0-.796-.33h-5.751a2.25 2.25 0 0 0-2.25 2.25v9C9.75 15.995 10.76 17 12 17h6.75A2.257 2.257 0 0 0 21 14.75V6.778c0-.298-.12-.584-.33-.795m-1.357 8.767c0 .31-.252.563-.563.563H11.97a.563.563 0 0 1-.563-.563V5.755c0-.311.252-.563.563-.563h4.5l.031 1.683c0 .621.504 1.125 1.125 1.125h1.656v6.75zm-6.75 4.5c0 .31-.252.563-.563.563H5.218a.563.563 0 0 1-.562-.563l.03-8.996c0-.311.253-.563.563-.563h3.376V8H5.25A2.25 2.25 0 0 0 3 10.25v9a2.25 2.25 0 0 0 2.25 2.25H12a2.257 2.257 0 0 0 2.25-2.25v-1.125h-1.656z"
    }));
export default SvgCopy;
